// extracted by mini-css-extract-plugin
export default {"swiper-slide-active":"Motability7Slide_swiper-slide-active__02PAe","wrapper":"Motability7Slide_wrapper__ASRd3","slideImage":"Motability7Slide_slideImage__WKU+u"};